import { render } from "./MessageSelector.vue?vue&type=template&id=529ced86"
import script from "./MessageSelector.vue?vue&type=script&lang=js"
export * from "./MessageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__